import { ComboBoxDropDownItem } from "@/Common/Components/Inputs/Combobox";
import { Locale } from "@/Common/Models/Localization/Locale";

class Unit {
    public Id: number;
    public CodeEn: string;
    public CodeFr: string;
    public CodeESMX: string;
    public DescriptionFr: string;
    public DescriptionEn: string;
    public DescriptionESMX: string;
    public Position: number;
    public IsTotalUnits?: boolean;

    public static getLocalizedCode(unit: Unit): string {
        switch (sessionStore.locale) {
            case Locale.fr: return unit.CodeFr;
            case Locale.es: return unit.CodeESMX;
            default: return unit.CodeEn;
        }
    }

    public static getLocalizedDescription(unit: Unit): string {
        switch (sessionStore.locale) {
            case Locale.fr: return unit.DescriptionFr;
            case Locale.es: return unit.DescriptionESMX;
            default: return unit.DescriptionEn;
        }
    }

    public static toComboboxItem(unit: Unit): ComboBoxDropDownItem {
        var GroupName = "";
        if (unit.Position != null)
            GroupName = cacheStore.GetString("PreferredLabel");
        else
            GroupName = cacheStore.GetString("OtherLabel");

        return new ComboBoxDropDownItem(unit.Id.toString(), Unit.getLocalizedDescription(unit) + " (" + Unit.getLocalizedCode(unit) + ")", unit.Position, GroupName);
    }
}

export { Unit };
